import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    saveReminderBundle(formData) {
        return Axios.post(
            `${baseURL}schedule/bundle/create-reminder`,
            formData
        ).then(response => response.data.response);
    }
};
